'use strict';

export class Hero {
	constructor(component_id) {
		this.id = component_id;
		this.element = document.querySelector(`.js-${component_id}`);
		this.init();
	}
	
	init() {

	}
}

// Auto-initialize
Object.keys(yalwa.v.components).forEach(key => {
	if (key.startsWith('hero_')) {
		new Hero(key);
	}
});